import React, { useCallback } from 'react';
import { Alert } from 'react-native';
import { IconEdit, SettingsItem } from 'design-system';
import Modal from 'utils/packages/Modal';
import { IconHome, IconTrash } from 'design-system/icons';
import { Tier } from 'features/premium/entities';
import { muteAll, useFetchOld } from 'hooks';
import { formatAddress } from 'utils';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { deleteRentReportingById } from '../actions';
import useNavigateToStartOnboardingFlow from '../hooks/useNavigateToStartOnboardingFlow';
const strings = {
    startNew: 'Start new reporting',
    startNewDescription: 'Create new reporting if you have moved to new place or your payment frequency has changed',
    updateDetails: 'Update details',
    changeAmountOrAccount: 'Change the rental payment amount or the account you pay rent from',
    stopReporting: 'Delete',
    stopReportingAtThisAddress: 'Stop reporting rent payments at this address',
};
export const showRentReportingManageModal = (rentReportingData) => Modal.show(<RentReportingManageModal rentReportingData={rentReportingData}/>, {
    title: 'Manage reporting',
    containerStyle: { paddingHorizontal: 0 },
});
const RentReportingManageModal = ({ rentReportingData }) => {
    const navigation = useMainStackNavigation();
    const startNew = useNavigateToStartOnboardingFlow(navigation);
    const onPressStartNewTracking = useCallback(() => Modal.hide(startNew), [startNew]);
    const onPressUpdateDetails = useCallback(() => {
        Modal.hide(() => {
            if (!rentReportingData.reportingAgencies?.length) {
                navigation.navigateDeprecated('EmmaProModal', {
                    tier: Tier.plus,
                    skipTrialScreen: true,
                    benefitId: 'rentReporting',
                });
            }
            else if (rentReportingData.isTracking) {
                navigation.navigateDeprecated('RentReportingOnboardingPayment', {
                    id: rentReportingData.id,
                    isEditing: true,
                    currency: rentReportingData.currency,
                    amount: rentReportingData.amount,
                    frequency: rentReportingData.frequency,
                    tenancyAddressId: rentReportingData.tenancyAddressId,
                    accountId: rentReportingData.accountId,
                });
            }
            else {
                navigation.navigateDeprecated('RentReportingDifferentAddress', {
                    id: rentReportingData.id,
                    currency: rentReportingData.currency,
                    amount: rentReportingData.amount,
                    frequency: rentReportingData.frequency,
                    tenancyAddressId: rentReportingData.tenancyAddressId,
                    accountId: rentReportingData.accountId,
                });
            }
        });
    }, [
        rentReportingData.amount,
        rentReportingData.currency,
        rentReportingData.frequency,
        rentReportingData.id,
        rentReportingData.isTracking,
        rentReportingData.reportingAgencies?.length,
        rentReportingData.tenancyAddressId,
    ]);
    const [, , , fetch] = useFetchOld(muteAll);
    const onPressStopReporting = useCallback(async () => {
        Modal.hide(() => {
            Alert.alert('Stop reporting rent?', `Are you sure you want to stop reporting rent for ${rentReportingData?.tenancyAddress
                ? formatAddress(rentReportingData?.tenancyAddress)
                : 'this address'}?`, [
                {
                    text: 'Yes',
                    style: 'destructive',
                    onPress: async () => {
                        await fetch(deleteRentReportingById(rentReportingData.id));
                        navigation.goBack();
                    },
                },
                {
                    text: 'Cancel',
                    style: 'cancel',
                },
            ]);
        });
    }, [rentReportingData.id, rentReportingData.tenancyAddress]);
    return (<>
      <SettingsItem icon={<IconHome gradientKey="apricot"/>} title={strings.startNew} description={strings.startNewDescription} onPress={onPressStartNewTracking}/>
      <SettingsItem icon={<IconEdit gradientKey="ultimate"/>} title={strings.updateDetails} description={strings.changeAmountOrAccount} onPress={onPressUpdateDetails}/>
      <SettingsItem icon={<IconTrash colorKey="negative"/>} title={strings.stopReporting} description={strings.stopReportingAtThisAddress} onPress={onPressStopReporting}/>
    </>);
};
export default RentReportingManageModal;
